import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { PublicLayout } from '../layouts/public.layout';
import { HomePage } from '../pages/public/home.page';
import { CatalogoPage as PublicCatalogoPage } from '../pages/public/catalogo.page';
import { ProductoDetallePage } from '../pages/public/producto-detalle.page';
import { NosotrosPage } from '../pages/public/nosotros.page';
import { ContactoPage as PublicContactoPage } from '../pages/public/contacto.page';
import { LoginPage } from '../pages/login.page';
import { ProtectedRoute } from './protected-route';
import { PublicRoute } from './public-route';

// Code-splitting diferido para el panel de administración privado (Dashboard)
const DashboardLayout = lazy(() =>
  import('../layouts/dashboard.layout').then((m) => ({ default: m.DashboardLayout }))
);
const InicioPage = lazy(() =>
  import('../pages/dashboard/inicio.page').then((m) => ({ default: m.InicioPage }))
);
const DashboardCatalogoPage = lazy(() =>
  import('../pages/dashboard/catalogo.page').then((m) => ({ default: m.CatalogoPage }))
);
const BannersPage = lazy(() =>
  import('../pages/dashboard/banners.page').then((m) => ({ default: m.BannersPage }))
);
const PromocionesPage = lazy(() =>
  import('../pages/dashboard/promociones.page').then((m) => ({ default: m.PromocionesPage }))
);
const EstadisticasPage = lazy(() =>
  import('../pages/dashboard/estadisticas.page').then((m) => ({ default: m.EstadisticasPage }))
);
const MarcasPage = lazy(() =>
  import('../pages/dashboard/marcas.page').then((m) => ({ default: m.MarcasPage }))
);
const ClientesPage = lazy(() =>
  import('../pages/dashboard/clientes.page').then((m) => ({ default: m.ClientesPage }))
);
const CategoriasPage = lazy(() =>
  import('../pages/dashboard/categorias.page').then((m) => ({ default: m.CategoriasPage }))
);
const CualidadesPage = lazy(() =>
  import('../pages/dashboard/cualidades.page').then((m) => ({ default: m.CualidadesPage }))
);
const VideosPage = lazy(() =>
  import('../pages/dashboard/videos.page').then((m) => ({ default: m.VideosPage }))
);
const PlantillasPage = lazy(() =>
  import('../pages/dashboard/plantillas.page').then((m) => ({ default: m.PlantillasPage }))
);
const RedesSocialesPage = lazy(() =>
  import('../pages/dashboard/redes-sociales.page').then((m) => ({ default: m.RedesSocialesPage }))
);
const DashboardContactoPage = lazy(() =>
  import('../pages/dashboard/contacto.page').then((m) => ({ default: m.ContactoPage }))
);
const UsuariosPage = lazy(() =>
  import('../pages/dashboard/usuarios.page').then((m) => ({ default: m.UsuariosPage }))
);
const PerfilesPage = lazy(() =>
  import('../pages/dashboard/perfiles.page').then((m) => ({ default: m.PerfilesPage }))
);
const AuditLogsPage = lazy(() =>
  import('../pages/dashboard/audit-logs.page').then((m) => ({ default: m.AuditLogsPage }))
);

const PageFallback: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-950">
    <div className="w-8 h-8 border-3 border-brand-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* 1. Experiencia Pública BARTECH (Catálogo, Soluciones y Contacto) */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/catalogo" element={<PublicCatalogoPage />} />
        <Route path="/productos" element={<PublicCatalogoPage />} />
        <Route path="/catalogo/:slug" element={<ProductoDetallePage />} />
        <Route path="/producto/:slug" element={<ProductoDetallePage />} />
        <Route path="/productos/:slug" element={<ProductoDetallePage />} />
        <Route path="/nosotros" element={<NosotrosPage />} />
        <Route path="/contacto" element={<PublicContactoPage />} />
      </Route>

      {/* 2. Autenticación (Solo accesible sin sesión activa) */}
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      {/* 3. Experiencia Privada BARTECH Dashboard (Protegida con Code-Splitting) */}
      <Route element={<ProtectedRoute />}>
        <Route
          path="/dashboard"
          element={
            <Suspense fallback={<PageFallback />}>
              <DashboardLayout />
            </Suspense>
          }
        >
          <Route index element={<InicioPage />} />
          <Route path="estadisticas" element={<EstadisticasPage />} />
          <Route path="catalogo" element={<DashboardCatalogoPage />} />
          <Route path="marcas" element={<MarcasPage />} />
          <Route path="clientes" element={<ClientesPage />} />
          <Route path="categorias" element={<CategoriasPage />} />
          <Route path="plantillas" element={<PlantillasPage />} />
          <Route path="cualidades" element={<CualidadesPage />} />
          <Route path="videos" element={<VideosPage />} />
          <Route path="banners" element={<BannersPage />} />
          <Route path="promociones" element={<PromocionesPage />} />
          <Route path="redes-sociales" element={<RedesSocialesPage />} />
          <Route path="contacto" element={<DashboardContactoPage />} />
          <Route path="usuarios" element={<UsuariosPage />} />
          <Route path="perfiles" element={<PerfilesPage />} />
          <Route path="auditoria" element={<AuditLogsPage />} />
        </Route>
      </Route>

      {/* 4. Redirección por defecto a la página de Inicio pública */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
